import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import FormBuilder from "../components/FormBuilder/FormBuilder";
import {
  Button,
  Box,
  Grid,
  Link,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  Alert,
  Snackbar,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ACTION, USERROLE } from "../utils/commonConstant";
import {
  fetchAdminHHContractById,
  fetchTemplateLibraryDataById,
} from "../api/contractVersionService";
import FileUploadPopup from "../ModelPopup/FileUploadPopup";
import ContractPreviewPopup from "../ModelPopup/ContractPreviewPopup";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";
import MenuIcon from "@mui/icons-material/Menu";

const FormEditorPage = () => {
  const [elements, setElements] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const { clientId, action, contractVersionId, templateId, hhDocumentId } =
    useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [openFileUploadPopup, setOpenFileUploadPopup] = useState(false);
  const [fileuploadData, setFileUploadData] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleOpenPreview = () => {
    if (elements.length === 0) {
      toast.error("Please add elements in form.");
      return;
    }
    setOpenPreview(true);
  };
  const handleModelDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedOption(null);
  };
  const handleSubmitMarkel = async () => {
    const data = await fetchAdminHHContractById(contractId);
    setFileUploadData(data);
    setOpenFileUploadPopup(true);
  };
  const handleClosePreview = () => setOpenPreview(false);
  const [contractId, setContractId] = useState(contractVersionId ?? null);
  const [hhContract, setHhContract] = useState({
    versionname: "",
    subcontractorType: "",
    isMarkelApproval: true,
  });
  const [errors, setErrors] = useState({
    versionname: "",
    subcontractorType: "",
  });
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const fetchTemplateById = async () => {
    const data = await fetchTemplateLibraryDataById(templateId);
    setElements((prevElements) => [...prevElements, ...data]);
  };
  const handleAutocompleteChange = (event, newValue) => {
    setErrors({ ...errors, subcontractorType: "" });
    setSelectedOption(newValue);
    console.log("in handleAutocompleteChange...");
    if (newValue) {
      setHhContract((prev) => ({
        ...prev,
        subcontractorType: selectedOption.Id ?? "",
      }));
    }
  };
  // Function to handle save action
  const handleSave = async () => {
    if (elements.length === 0) {
      toast.error("Please add elements in form.");
      return;
    }
    setIsSaving(false);
    setEditDialogOpen(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  useEffect(() => {
    // Code that depends on hhContract
    console.log("hhContract updated:", hhContract);
  }, [hhContract]);

  const handleFileUploadPopupClose = () => {
    setOpenFileUploadPopup(false);
    setFileUploadData(null);
  };
  const fetchForm = async () => {
    try {
      const res = await fetchFromWebApi(
        `HHContract/GetActiveHHContractstByClientId?clientId=${clientId}`,
        {
          method: "GET",
        }
      );
      // Handle response
      if (res?.ok) {
        let json = await res.json();
        console.log(json, "jsondata");
        setElements(json.MetaData);
        setContractId(json.Id);
        setHhContract((prevHHContract) => ({
          ...prevHHContract,
          versionname: json.VersionName,
        }));
        setSelectedOption({
          Id: json.SubcontractorTypeId,
          Name: json.SubcontractorType,
        });
        console.log("Form saved successfully!");
      } else {
        setElements([]);
        // Handle error response
        console.error("Failed to save form:", await res.text());
      }
    } catch (error) {
      // Handle network errors
      console.error("Error while saving form:", error);
    }
  };

  const fetchEditForm = async () => {
    try {
      const res = await fetchFromWebApi(
        `HHContract/GetAdminHHContractsById?Id=${contractId}`,
        {
          method: "GET", }
      );
      // Handle response
      if (res?.ok) {
        let json = await res.json();
        console.log(json, "jsondata");
        setElements(json.MetaData);
        setContractId(json.Id);
        setHhContract((prevHHContract) => ({
          ...prevHHContract,
          versionname: json.VersionName,
          isMarkelApproval: json.IsMarkelApproval,
        }));
        setSelectedOption({
          Id: json.SubcontractorTypeId,
          Name: json.SubcontractorType,
        });
        setOpenSnackbar(true);
        console.log("Form saved successfully!");
      } else {
        // Handle error response
        console.error("Failed to save form:", await res.text());
      }
    } catch (error) {
      // Handle network errors
      console.error("Error while saving form:", error);
    }
  };
  const handleRedirectVersion = () => {
    navigate(`/${clientId}/${hhDocumentId}/${templateId}`);
    //window.history.back();
  };
  useEffect(() => {
    if (ACTION.CREATE === action) {
      setContractId(null);
    } else if (ACTION.EDIT === action) {
      fetchEditForm();
    } else {
      fetchForm();
    }
  }, [action]);
  useEffect(() => {
    if (selectedOption) {
      setHhContract((prev) => ({
        ...prev,
        subcontractorType: selectedOption.Id ?? "",
      }));
    }
    console.log(selectedOption, "selectedOption");
  }, [selectedOption]);
  useEffect(() => {
    if (action === ACTION.CREATE) {
      fetchTemplateById();
    }
  }, [templateId]);

  useEffect(() => {
    console.log("ELEMENT UPDATED FROM FORMEDITOR", elements);
    setElements(elements);
  }, [elements, setElements]);

  // Styles for the modal
  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
    maxHeight: "90vh",
  };

  if (!clientId) {
    return null;
  }
  const handleInputChange = (event) => {
    console.log(event.target);
    const { name, value, type, checked } = event.target;
    const updatedValue = type === "checkbox" ? checked : value;
    setHhContract((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
    setErrors({ ...errors, [name]: "" });
  };
  const handleEditSave = async () => {
    debugger;
    if (isSaving) return;
    let formValid = true;
    const newErrors = { ...errors };
    // Basic validation
    if (!hhContract.versionname) {
      newErrors.versionname = "Version Name is required";
      formValid = false;
    }
    if (!formValid) {
      setErrors(newErrors);
      return;
    }
    setIsSaving(true);
    setEditDialogOpen(false);
    try {
      const res = await fetchFromWebApi(
        `HHContract/Create`,
        {
          method: "POST",
          body: JSON.stringify({
            clientId: clientId,
            versionName: hhContract.versionname,
            metaData: elements,
            id: contractId,
            //subcontractorType: hhContract.subcontractorType,
            templateId: templateId,
            hhDocumentId: hhDocumentId,
            //isMarkelApproval:hhContract.isMarkelApproval
          }),
        }
      );

      if (res?.ok) {
        toast.success("Form saved successfully.");
        const result = await res.json();
        setContractId(result.Id);
        navigate(
          `/${clientId}/${hhDocumentId}/versions/${templateId}/${ACTION.EDIT}/${result.Id}`
        );
      } else {
        toast.error("Failed to save form:", await res.text());
      }
    } catch (error) {
      toast.error("Error while saving form:", error);
    }
  };
  return (
    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "white",
          zIndex: 1000,
          boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <Snackbar
          open={openSnackbar}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {`This is  Edit for Version Name is ${hhContract.versionname}`}
          </Alert>
        </Snackbar>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ marginBottom: 3 }}
        >
          <Grid item xs={12} sm="auto" display="flex" justifyContent="center">
            <Link href={`/${clientId}`}>
              <img
                src="https://portal.hardhats.co.uk/img/Hardhats-Logo.png"
                alt="HardHats Logo"
                style={{ width: "80px", marginRight: "20px" }}
              />
            </Link>
          </Grid>
          <Grid item xs={12} sm="auto">
            <h2 style={{ textAlign: "center" }}>Contract for Services</h2>
          </Grid>
        </Grid>
        <Grid container justifyContent="space-between" spacing={2}>
          {/* Left Side Buttons */}
          <Grid item>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <IconButton
                  onClick={() => setIsCollapsed(!isCollapsed)} // Toggle collapse state
                  sx={{ marginBottom: 0 }}
                >
                  <MenuIcon  color="primary"/>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>

          {/* Right Side Buttons */}
          <Grid item>
            <Grid container spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenPreview}
                >
                  Preview Form
                </Button>
              </Grid>
              {contractId && (
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitMarkel}
                  >
                    Send To Client
                  </Button>
                </Grid>
              )}
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                >
                  {action === ACTION.EDIT ? "Update" : "Save"}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleRedirectVersion}
                >
                  Back
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <FormBuilder
        submitForm={handleEditSave}
        elements={elements}
        setElements={setElements}
        isTemplate={false}
        isCollapsed={isCollapsed} // Pass the collapse state to FormBuilder
      />

      <ContractPreviewPopup
        open={openPreview}
        onClose={handleClosePreview}
        elements={elements}
        clientId={clientId}
        trackChangeDisplayBy={USERROLE.ADMIN}
        isShowTrackHistory={true}
        setElements={setElements}
        isEditable={true}
      />

      {/* model popup for contract version */}
      <Dialog
        open={editDialogOpen}
        onClose={handleModelDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle>
          {ACTION.CREATE === action
            ? "Create Contract Version"
            : "Edit Contract Version"}
        </DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <TextField
            margin="dense"
            label="Version Name"
            variant="outlined"
            name="versionname"
            value={hhContract.versionname}
            type="text"
            fullWidth
            onChange={handleInputChange}
            error={!!errors.versionname}
            helperText={errors.versionname}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModelDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEditSave} color="primary" disabled={isSaving}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <FileUploadPopup
        open={openFileUploadPopup}
        onClose={handleFileUploadPopupClose}
        data={fileuploadData}
        isFromEditor={true}
      />
    </Box>
  );
};

export default FormEditorPage;
